import { render, staticRenderFns } from "./ResourceLibrarySelect.vue?vue&type=template&id=7a668533&scoped=true"
import script from "./ResourceLibrarySelect.vue?vue&type=script&lang=js"
export * from "./ResourceLibrarySelect.vue?vue&type=script&lang=js"
import style0 from "./ResourceLibrarySelect.vue?vue&type=style&index=0&id=7a668533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a668533",
  null
  
)

export default component.exports